import paper from 'paper';
import { Point, Size } from 'paper';
import PathStyle from '../../services/PathStyle';
import ToolsUtils from '../../services/ToolsUtils';
import { models } from 'feathers-vuex';

const state = {
    propRadius: null,
    propRotation: null,
    propCorner: null,
    propPockets: null,
    propPosition: null,
    propSize: null,
    propKeepProportions: null,
    propHeightPos: null,
    propFontName: null,
    propFontSize: null,
    propAutoSize: null,
    propTextContent: null,
    propIconName: null,
    maxCorner: null,
    selectedShape: null,
    allowRepaint: true,
    allowCommit: true,
    propCornerBottomRight : null,
    propCornerTopRight : null, 
    propCornerBottomLeft : null,
    propCornerTopLeft : null,
    propCenterMarking : false
};

const mutations = {
    'SET_RADIUS'(state, radius) { state.propRadius = radius },
    'SET_ROTATION'(state, rotation) { state.propRotation = rotation },
    'SET_CORNER'(state, corner) { state.propCorner = corner },
    'SET_POCKETS'(state, pockets) { state.propPockets = pockets },
    'SET_POSITION'(state, position) { state.propPosition = position },
    'SET_SIZE'(state, size) { state.propSize = size },
    'SET_MAX_CORNER'(state, maxCorner) { state.maxCorner = maxCorner },
    'SET_KEEP_PROPORTIONS'(state, keepProportions) { state.keepProportions = keepProportions},
    'SET_HEIGHT_POS'(state, propHeightPos) { state.propHeightPos = propHeightPos},
    'SET_SELECTED_SHAPE'(state, shape) { state.selectedShape = shape },
    'SET_ALLOW_REPAINT'(state, allow) { state.allowRepaint = allow },
    'SET_ALLOW_COMMIT'(state, allow) { state.allowCommit = allow },
    'SET_FONT_NAME'(state, fontName) { state.propFontName = fontName },
    'SET_FONT_SIZE'(state, fontSize) { state.propFontSize = fontSize },
    'SET_AUTO_SIZE'(state, autoSize) { state.propAutoSize = autoSize },
    'SET_TEXT_CONTENT'(state, content) { state.propTextContent = content },
    'SET_ICON_NAME'(state, iconName) { state.propIconName = iconName },
    'SET_CORNER_BOTTOM_RIGHT'(state, cornerBottomRight) { state.propCornerBottomRight = cornerBottomRight},
    'SET_CORNER_TOP_RIGHT'(state, cornerTopRight) { state.propCornerTopRight = cornerTopRight},
    'SET_CORNER_BOTTOM_LEFT'(state, cornerBottomLeft) { state.propCornerBottomLeft = cornerBottomLeft},
    'SET_CORNER_TOP_LEFT'(state, cornerTopLeft) { state.propCornerTopLeft = cornerTopLeft},
    'SET_CENTER_MARKING'(state,centerMarking) {state.propCenterMarking = centerMarking}
};
function commitShapeProperties({commit}, shape){
    if (shape.accepts('resize-radius')) {
        commit('SET_RADIUS', Math.round(10 * parseFloat(shape.radius)) / 10);
    }

    if (shape.accepts('rotate')) {
        commit('SET_ROTATION', parseFloat(shape.rotation) || 0);
    }

    if (shape.accepts('round-corners')) {

        let width = Math.round(parseFloat(shape.size.width));
        let height = Math.round(parseFloat(shape.size.height));
        if (width < height) {
            commit('SET_MAX_CORNER', Math.round(width * 5) / 10);
        }
        else {
            commit('SET_MAX_CORNER', Math.round(height * 5) / 10);
        }
        commit('SET_CORNER', parseFloat(shape.corner.height) || 0);

        if (shape.roundCorner) {
            commit('SET_CORNER_TOP_LEFT', shape.roundCorner.topLeft)
            commit('SET_CORNER_BOTTOM_LEFT', shape.roundCorner.bottomLeft)
            commit('SET_CORNER_TOP_RIGHT', shape.roundCorner.topRight)
            commit('SET_CORNER_BOTTOM_RIGHT', shape.roundCorner.bottomRight)
        }
    }

    if (shape.accepts('pockets')) {
        commit('SET_POCKETS', shape.pockets);
    }

    if (shape.accepts('move')) {
        let referencePoint = new Point(shape.referencePoint());
        commit('SET_POSITION', {
            x: Math.round(referencePoint.x),
            y: Math.round(-referencePoint.y)
        })
    }

    if (shape.accepts('resize')) {
        commit('SET_SIZE', {
            width: Math.round(parseFloat(shape.size.width)),
            height: Math.round(parseFloat(shape.size.height)),
        }),
        commit('SET_KEEP_PROPORTIONS', shape.keepProportions);
    }

    if (shape.accepts('triangle')) {
        commit('SET_HEIGHT_POS',  Math.round(parseFloat(shape.heightPos) * parseFloat(shape.size.width)));
    }

    if (shape.accepts('text')) {
        commit('SET_FONT_NAME', shape.font);
        commit('SET_FONT_SIZE', shape.fontSize);
        commit('SET_AUTO_SIZE', shape.autoSize);
        commit('SET_TEXT_CONTENT', shape.content);
    }

    if (shape.accepts('svg')) {
        commit('SET_ICON_NAME', shape.iconName);
    }
}

const actions = {
    setRadius: async ({ commit, getters, dispatch }, {radius, center, size = null, oldSize = null, oldCenterBounds = null}) => {
        if (getters.selectedShape != null && getters.selectedShape.accepts('resize-radius')){
            let ratio = radius / getters.selectedShape.radius;
            let oldCenter = getters.selectedShape.center;
            getters.selectedShape.radius = radius;
            let ratioPositionX = center.x - oldCenter.x;
            let ratioPositionY = center.y - oldCenter.y;
            let intersects = getters.shapes.filter(shapes => getters.selectedShape.bounds.intersects(shapes.bounds) &&  getters.selectedShape.id != shapes.id && shapes.isCut && !getters.selectedShape.isCut);
            intersects.forEach(intersect => {
                let cutIntersectWithMatter = getters.shapes.filter(shapes => intersect.bounds.intersects(shapes.bounds) && getters.selectedShape.id != shapes.id && !shapes.isCut);
                if(cutIntersectWithMatter.length == 0){
                    let centerX = intersect.center.x + ratioPositionX;
                    let centerY = intersect.center.y + ratioPositionY;
                    if(intersect.accepts('resize-radius')){
                        intersect.radius = intersect.radius * ratio;
                        if(intersect.radius < getters.cuttingOptions.drillingThresholdDiameter/2){
                            intersect.radius = ToolsUtils.drillingDiameter(intersect.radius, getters.cuttingOptions.drillingThresholdDiameter/2, getters.cuttingOptions);
                        }
                    }else{
                        let newSize = {
                            width : intersect.size.width * ratio,
                            height : intersect.size.height * ratio,
                        }
                        intersect.size = newSize;                    
                    }
                    intersect.center = new Point(
                        centerX,
                        centerY,
                    );
                }
            });
        }else if(getters.selectedShapeIds.length > 0){
            let ratioWidth = size.width / oldSize.width;
            let ratioHeight = size.height / oldSize.height;
            let ratio = (ratioHeight + ratioWidth) / 2;
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape =>{
                if(shape.accepts('resize-radius')){
                    shape.radius = (shape.radius ) * ratio;
                    let oldCenter = shape.center; 
                    let centerX = (oldCenter.x) * (ratio);
                    let centerY = (oldCenter.y) * (ratio);
                    shape.center = new Point(
                        centerX,
                        centerY,
                    );
                }
            });  
        }

        if (getters.allowCommit) commit('SET_RADIUS', radius);

        await dispatch('redrawSelected');
    },

    setRotation: async ({ commit, getters, dispatch }, rotation) => {
        if (getters.selectedShape != null && getters.selectedShape.accepts('rotate')){
            getters.selectedShape.rotation = rotation;

            if (getters.allowCommit) commit('SET_ROTATION', rotation);

            await dispatch('redrawSelected');
        }else if(getters.selectedShapeIds.length > 0){
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape => {
                if(shape.accepts('rotate')){
                    shape.rotation = rotation;
                }
            });

            if (getters.allowCommit) commit('SET_ROTATION', rotation);

            await dispatch('redrawSelected');
        }
    },

    setCorner: async ({ commit, getters, dispatch }, corner) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('round-corners')) return;
        getters.selectedShape.corner = new Size(corner, corner);

        if (getters.allowCommit) commit('SET_CORNER', corner);

        await dispatch('redrawSelected');
    },

    setPockets: async ({ commit, getters, dispatch }, pockets) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('pockets')) return;
        getters.selectedShape.pockets = pockets;

        if (getters.allowCommit) commit('SET_POCKETS', pockets);

        await dispatch('redrawSelected');
    },

    setPosition: async ({ commit, getters, dispatch }, position) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('move')) return;

        let oldReferencePoint = new Point(getters.selectedShape.referencePoint());
        oldReferencePoint.x = parseFloat(oldReferencePoint.x);
        oldReferencePoint.y = parseFloat(oldReferencePoint.y);
        
        position.x = parseFloat(position.x);
        position.y = -parseFloat(position.y);

        let delta = {
            x:0,
            y:0
        };
        delta.x = position.x - oldReferencePoint.x;
        delta.y = position.y - oldReferencePoint.y;
        getters.selectedShape.move(delta);

        let referencePoint = new Point(getters.selectedShape.referencePoint());
        if (getters.allowCommit) commit('SET_POSITION', {
            x: Math.round(referencePoint.x),
            y: Math.round(-referencePoint.y)
        });

        await dispatch('redrawSelected');
    },

    setShapeCenter: async ({ commit, getters, dispatch }, center) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('move')) return;
        getters.selectedShape.center = center;

        if (getters.allowCommit) commit('SET_POSITION', {
            x: Math.round(center.x - getters.origin.x),
            y: Math.round(getters.origin.y - center.y)
        });

        await dispatch('redrawSelected');
    },

    moveShape: async ({ commit, getters, dispatch }, delta) => {
        if (getters.selectedShape != null && getters.selectedShape.accepts('move')){
            let intersects = getters.shapes.filter(shapes => getters.selectedShape.bounds.intersects(shapes.bounds) &&  getters.selectedShape.id != shapes.id && shapes.isCut && !getters.selectedShape.isCut);
            intersects.forEach(intersect => {
                let cutIntersectWithMatter = getters.shapes.filter(shapes => intersect.bounds.intersects(shapes.bounds) && getters.selectedShape.id != shapes.id && !shapes.isCut);
                if(cutIntersectWithMatter.length == 0){
                    intersect.move(delta);
                }
            });
            getters.selectedShape.move(delta);
            if (getters.allowCommit) commit('SET_POSITION', {
                x: Math.round(getters.selectedShape.center.x - getters.origin.x),
                y: Math.round(getters.origin.y - getters.selectedShape.center.y)
            })
            await dispatch('redrawSelected');
        }else if(getters.selectedShapeIds.length > 0){
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape =>{
                if(shape.accepts('move')){
                    shape.move(delta);
                    if (getters.allowCommit) commit('SET_POSITION', {
                        x: Math.round(shape.center.x - getters.origin.x),
                        y: Math.round(getters.origin.y - shape.center.y)
                    })
                };

                let intersects = getters.shapes.filter(shap =>shape.bounds.intersects(shap.bounds) && shape.id != shap.id && shap.isCut && !shape.isCut && !getters.selectedShapeIds.includes(shap.id));
                intersects.forEach(intersect => {
                    let cutIntersectWithMatter = getters.shapes.filter(shap => intersect.bounds.intersects(shap.bounds) && shape.id != shap.id && !shap.isCut);
                    if(cutIntersectWithMatter.length == 0){
                        intersect.move(delta);
                    }
                });
            })
            await dispatch('redrawSelected');
        }
    },

    setSize: async ({ commit, getters, dispatch }, {size, center, oldSize = null, oldCenterBounds = null}) => {
        if (getters.selectedShape != null && getters.selectedShape.accepts('resize')){
            let ratioHeight = size.height / getters.selectedShape.size.height;
            let ratioWidth = size.width / getters.selectedShape.size.width;
            let oldCenter = getters.selectedShape.center;
            getters.selectedShape.size = size;
            let ratioPositionX = center.x - oldCenter.x;
            let ratioPositionY = center.y - oldCenter.y;
            let intersects = getters.shapes.filter(shapes => getters.selectedShape.bounds.intersects(shapes.bounds) &&  getters.selectedShape.id != shapes.id && shapes.isCut && !getters.selectedShape.isCut);
            intersects.forEach(intersect => {
                let cutIntersectWithMatter = getters.shapes.filter(shapes => intersect.bounds.intersects(shapes.bounds) && getters.selectedShape.id != shapes.id && !shapes.isCut);
                if(cutIntersectWithMatter.length == 0){
                    let centerX = intersect.center.x + ratioPositionX;
                    let centerY = intersect.center.y + ratioPositionY;
                    if(intersect.accepts('resize-radius')){
                        intersect.radius = (intersect.radius * ((ratioHeight + ratioWidth)) /2);
                        if(intersect.radius < getters.cuttingOptions.drillingThresholdDiameter/2){
                            intersect.radius = ToolsUtils.drillingDiameter(intersect.radius, getters.cuttingOptions.drillingThresholdDiameter/2, getters.cuttingOptions);
                        }
                    }else{
                        let newSize = {
                            width : intersect.size.width ? intersect.size.width * ratioWidth : 0,
                            height : intersect.size.height * ratioHeight,
                        }
                        intersect.size = newSize;                    
                    }
                    intersect.center = new Point(
                        centerX,
                        centerY,
                    );
                }
            });
    
            if (getters.allowCommit) commit('SET_SIZE', size);
        }else{
            let ratioWidth = size.width / oldSize.width;
            let ratioHeight = size.height / oldSize.height;
            let ratioSize = (ratioWidth + ratioHeight) /2;
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape =>{
                if(shape.accepts('resize')){
                    let newSize = {
                        width: shape.size.width * ratioSize,
                        height: shape.size.height * ratioSize
                    }
                    let oldCenter = shape.center;
                    shape.size = newSize;
                    let centerX = (oldCenter.x ) * ratioSize;
                    let centerY = (oldCenter.y ) * ratioSize;
                    shape.center = new Point(
                        centerX,
                        centerY,
                    );
                }
            });  
        }

        await dispatch('redrawSelected');
    },

    setHeightPos: async ({ commit, getters, dispatch }, propHeightPos ) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('triangle') ) return;
        propHeightPos =  Math.round(propHeightPos);
        let relativeHeightPos = propHeightPos / getters.selectedShape.size.width;
        getters.selectedShape.heightPos = relativeHeightPos;

        if (getters.allowCommit) commit('SET_HEIGHT_POS', propHeightPos);

        await dispatch('redrawSelected');
    },

    setFontName: async ({ commit, getters, dispatch }, font) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('text')) return;

        getters.selectedShape.font = font;

        if (getters.allowCommit) commit('SET_FONT_NAME', font);
        await dispatch('redrawSelected');
    },

    setFontSize: async ({ commit, getters, dispatch }, fontSize) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('text')) return;

        getters.selectedShape.fontSize = fontSize;

        if (getters.allowCommit) commit('SET_FONT_SIZE', fontSize);
        await dispatch('redrawSelected');
    },

    setAutoSize: async ({ commit, getters, dispatch }, autoSize) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('text')) return;

        getters.selectedShape.autoSize = autoSize;

        if (getters.allowCommit) commit('SET_AUTO_SIZE', autoSize);
        await dispatch('redrawSelected');
    },

    setTextContent: async ({ commit, getters, dispatch }, content) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('text')) return;

        getters.selectedShape.content = content;

        if (getters.allowCommit) commit('SET_TEXT_CONTENT', content);
        await dispatch('redrawSelected');
    },

    setIconName: async ({ commit, getters, dispatch }, iconName) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('svg')) return;

        getters.selectedShape.iconName = iconName;

        let icons = (await models.api.Icon.find({
            query: { name: iconName }
        })).data;

        if (icons.length < 1) {
            console.error("Icone " + iconName + " introuvable");
            return;
        }

        if (icons.length > 1) {
            console.warn("Plusieurs icones trouvées avec le nom " + iconName + ". La première est utilisée.");
        }
        let icon = icons[0];

        getters.selectedShape.pathData = icon.path;

        if (getters.allowCommit) commit('SET_ICON_NAME', iconName);
        await dispatch('redrawSelected');
    },

    setSelectedShape: ({ commit, dispatch }, shape) => {
        commit('SET_SELECTED_SHAPE', shape);
        if (shape) dispatch('commitProperties');
    },

    commitProperties: ({getters, commit}) => {
        let shape = getters.selectedShape;
        if(shape){
            commitShapeProperties({commit}, shape);
        }else{
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape => {
                commitShapeProperties({commit}, shape);
            });
        }
    },

    allowRepaint: async ({ commit, dispatch }) => {
        commit('SET_ALLOW_REPAINT', true);
        await dispatch('redrawSelected');
    },

    preventRepaint: ({ commit }) => {
        commit('SET_ALLOW_REPAINT', false);
    },

    allowCommit: async ({ commit, dispatch }) => {
        commit('SET_ALLOW_COMMIT', true);
        dispatch('commitProperties');
    },

    preventCommit: ({ commit }) => {
        commit('SET_ALLOW_COMMIT', false);
    },

    redrawSelected: async ({getters, dispatch}) => {
        if (getters.selectedShape) {
            getters.selectedShape.updatePath();
            let item = getters.selectedShape.item();
            PathStyle.transform(item);
            paper.tools.find(t => t.name === 'selecter').initSelectionRectangle();
            if (getters.allowRepaint) dispatch('patchShape', getters.selectedShape);
        }else if(getters.selectedShapeIds.length > 0){
            let shapes = getters.shapes.filter(shape => getters.selectedShapeIds.includes(shape.id));
            shapes.forEach(shape => {
                shape.updatePath();
                let item = shape.item();
                PathStyle.transform(item);
                paper.tools.find(t => t.name === 'selecter').initSelectionRectangle();
            })
            if (getters.allowRepaint) dispatch('patchShapes', shapes);
        }
    },

    setRoundCorner: async ({ commit, getters, dispatch }, roundCorner) => {
        if (getters.selectedShape == null || !getters.selectedShape.accepts('round-corners')) return;
        getters.selectedShape.roundCorner = roundCorner;
        if (getters.allowCommit){
            commit('SET_CORNER_TOP_LEFT', roundCorner.topLeft)
            commit('SET_CORNER_BOTTOM_LEFT', roundCorner.bottomLeft)
            commit('SET_CORNER_TOP_RIGHT', roundCorner.topRight)
            commit('SET_CORNER_BOTTOM_RIGHT', roundCorner.bottomRight)
        };

        await dispatch('redrawSelected');
    },

    setCenterMarking: async({commit}, state) => {
        commit('SET_CENTER_MARKING', state);
    }

};

const getters = {
    propRadius: state => state.propRadius,
    propRotation: state => state.propRotation,
    propCorner: state => state.propCorner,
    propPockets: state => state.propPockets,
    propPosition: state => state.propPosition,
    propSize: state => state.propSize,
    propKeepProportions: state => state.propKeepProportions,
    propHeightPos: state => state.propHeightPos,
    propFontName: state => state.propFontName,
    propFontSize: state => state.propFontSize,
    propAutoSize: state => state.propAutoSize,
    propTextContent: state => state.propTextContent,
    propIconName: state => state.propIconName,
    maxCorner: state => state.maxCorner,
    selectedShape: state => state.selectedShape,
    allowRepaint: state => state.allowRepaint,
    allowCommit: state => state.allowCommit,
    propCornerBottomRight: state => state.propCornerBottomRight,
    propCornerTopRight: state => state.propCornerTopRight,
    propCornerTopLeft: state => state.propCornerTopLeft,
    propCornerBottomLeft: state => state.propCornerBottomLeft,
    propCenterMarking : state => state.propCenterMarking
};

export default {
    state,
    mutations,
    actions,
    getters
};

